import { OpenInNew, SaveAlt } from '@mui/icons-material';
import { useFlag } from '@reflag/react-sdk';
import Menu from 'further-ui/components/Menu';
import { downloadFileFromTrpc } from 'further-ui/utils';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { useNotification } from 'hooks/ui/useNotification';
import api from 'lib/trpcClient';

type Props = {
  commitmentIds?: Array<string>;
  vehicleId?: string;
  hasDocuments: boolean;
};

const DownloadMenu: React.FC<Props> = ({
  commitmentIds,
  vehicleId,
  hasDocuments,
}) => {
  const { isEnabled: downloadSignedDocumentsEnabled } = useFlag(
    'commitment-page-download-signed-documents',
  );
  const { isEnabled: exportAllDataEnabled } = useFlag(
    'commitment-page-export-all-data',
  );
  const { error } = useNotification();
  const { mutateAsync: runExport } = api.commitments.export.useMutation(
    useHandleTrpcMutation()({
      invalidations: [],
    }),
  );

  const { mutateAsync: downloadSignedDocuments } =
    api.commitments.downloadSignedDocuments.useMutation(
      useHandleTrpcMutation()({
        invalidations: [],
      }),
    );

  return (
    <Menu
      handleVariant="square"
      handleSize="small"
      handleIcon={SaveAlt}
      items={[
        ...(downloadSignedDocumentsEnabled
          ? [
              {
                label: 'Download subscription documents',
                icon: SaveAlt,
                disabled: !hasDocuments,
                tooltip: hasDocuments
                  ? undefined
                  : 'There are no documents associated with this commitment.',
                onClick: async () => {
                  if (!commitmentIds || !vehicleId) return;
                  const data = await downloadSignedDocuments({
                    commitmentId: commitmentIds,
                    vehicleId,
                  });
                  downloadFileFromTrpc(data, () =>
                    error('No documents available.'),
                  );
                },
              },
            ]
          : []),
        ...(exportAllDataEnabled
          ? [
              {
                label: 'Export all data',
                icon: OpenInNew,
                onClick: async () => {
                  if (!commitmentIds || !vehicleId) return;
                  const data = await runExport({
                    commitmentId: commitmentIds,
                    vehicleId,
                  });
                  downloadFileFromTrpc(data, () =>
                    error('No documents available.'),
                  );
                },
              },
            ]
          : []),
      ]}
    />
  );
};

export default DownloadMenu;
